import { Component } from 'react';
import styled from 'styled-components';

import { VerticalList } from '~/components/Elements';
import Link from '~/components/Link';
import Time from '~/components/Time';
import { colors } from '~/utils/css-mixins';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${colors.text};

  &:hover {
    color: ${colors.link};
  }
`;

const Li = styled.li`
  line-height: 1.5;
  font-size: 16px;
`;

class RenderStarts extends Component {
  render() {
    const { starts } = this.props;
    return (
      <VerticalList>
        {starts.map(start => (
          <Li key={start.id}>
            <StyledLink
              to={{
                type: 'RACE',
                payload: {
                  date: start.race_date,
                  track: start.track_slug,
                  race_number: start.race_number,
                },
              }}
            >
              <b>{start.horse_name}</b>
              {', '}
              {start.track_name}{' '}
              <Time date={new Date(start.start_time)} format="d/M" />
              {', '}
              Lopp-
              {start.race_number}{' '}
            </StyledLink>
          </Li>
        ))}
      </VerticalList>
    );
  }
}

export default RenderStarts;
